module.exports = __webpack_public_path__ + "static/media/48281605_2308805115861333_3269498842822737920_o-thumb.cabcd2d2.jpg";